import Title from './title'
import PrivateLayout from '../../layouts/privateLayout'
import { Box, Grid } from '@mui/material';
import InfoDashboard from './infoDashboard';
import BasicBreadcrumbs from '../../components/breadcrumb';

const Index = () => {
  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BasicBreadcrumbs first="Dashboard" />
        </Box>
        <InfoDashboard />
      </Box>
    </PrivateLayout>
  )
}

export default Index;